import { render } from "./InicioComponent.vue?vue&type=template&id=7ea7a699&scoped=true"
import script from "./InicioComponent.vue?vue&type=script&lang=js"
export * from "./InicioComponent.vue?vue&type=script&lang=js"

import "./InicioComponent.vue?vue&type=style&index=0&id=7ea7a699&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ea7a699"]])

export default __exports__